var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"myChart",style:({ width: '100%', height: '35px' }),attrs:{"id":"myChart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }